import type { GameManifest } from "../contracts/game";
import { game2048Manifest } from "../games/2048/manifest";
import { aDarkRoomManifest } from "../games/a-dark-room/manifest";
import { carcadeCityManifest } from "../games/carcade-city/manifest";
import { momentumTrackManifest } from "../games/cram/manifest";
import { freecivManifest } from "../games/freeciv/manifest";
import { marblesManifest } from "../games/marble-madness/manifest";
import { sausageSimulatorManifest } from "../games/sausage-simulator/manifest";
import { sectorTraderManifest } from "../games/sector-trader/manifest";
import { ticTacWhoaManifest } from "../games/tic-tac-whoa/manifest";

/**
 * The public first-party launcher roster.
 *
 * Recovered or rejected source may remain in the repository without being
 * exposed as a public game. Keeping this explicit list prevents archived
 * variants from silently returning to the launcher.
 */
export const LOCAL_GAME_MANIFESTS: readonly GameManifest[] = [
  momentumTrackManifest,
  marblesManifest,
  ticTacWhoaManifest,
  sausageSimulatorManifest,
  game2048Manifest,
  carcadeCityManifest,
  aDarkRoomManifest,
  freecivManifest,
  sectorTraderManifest,
];
